import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'skc-ratify',
  template: `
    <p>
      ratify wsdsdsdsddsdsdorks!
    </p>
  `,
  styles: []
})
export class UiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
